<template>
  <main class="sa-content">
    <!-- <div v-if="loading">
    <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-top" />
  </div> -->
    <div class="sa-card-large">
      <div class="sa-mob-header">
          <h5 class="sa-card-tit">My appointments</h5>
          <button class="sa-btn-back" @click="$router.go(-1)">
              <i class="icon-arrow-left"></i>
            </button>
      </div>
      <div class="sa-mob-cont">
          <div class="sa-row">
            <div class="sa-col-xs12 sa-col-sm12 sa-col-md4 sa-col-lg4 ">
              <div class="sa-card sa-card-gray sa-card-noshadow sa-h-xs sa-h-sm" v-if="utid !== (4 || 3)">
                <strong class="sa-d-block">Select Service</strong>
                <div class="sa-appoint-radio">
                  <span  v-if="userInfo.utid == '1'">
                    <input type="radio" v-model="slctService" id="all" name="all" value="all" />
                    <label for="all">All</label>
                  </span>
                  <span v-if="userInfo.e_type == 'H'">
                    <input
                      type="radio"
                      id="home"
                      v-model="slctService"
                      name="home"
                      value="ST0"
                      checked
                    />
                    <label for="home">Home Visit</label>
                  </span>
                  <span v-if="userInfo.utid == '1'">
                    <input type="radio" v-model="slctService" id="video" name="video" value="ST1" />
                    <label for="video">Video Consultation(Basic)</label>
                  </span>
                  <span v-if="userInfo.utid == '1'">
                    <input type="radio" v-model="slctService" id="videoFollow" name="video" value="ST11" />
                    <label for="videoFollow">Video Consultation(Follow up)</label>
                  </span>
                </div>
              </div>
              <div class="sa-form-group sa-h-md-up">
                <i class="icon-down-arrow sa-form-icon"></i>
                <select class="sa-form-control" v-model="slctService">
                  <option v-if="userInfo.utid == '1'" value="all">
                      All
                    </option>
                    <option v-if="userInfo.e_type == 'H'" value="ST0">
                      Home Visit
                    </option>
                      <option v-if="userInfo.utid == '1'" value="ST1">
                          Video Consultation(Basic)
                      </option>
                      <option v-if="userInfo.utid == '1'" value="ST11">
                          Video Consultation(Follow up)
                      </option>
                </select>
              </div>
              <div class="sa-card sa-card-gray sa-card-noshadow sa-noshadowm"  :class="utid == (4 || 3) ? 'sa-nurse-apt' : ''">
                <strong class="sa-d-block sa-h-xs sa-h-sm">Appointments</strong>
                <div class="sa-appoint-radio">
                  <span>
                    <input
                      type="radio"
                      id="upComingAppoint"
                      v-model="radio"
                      name="upComingAppoint"
                      value="3"
                      checked
                    />
                    <label for="upComingAppoint">{{ utid == (4 || 3) ? 'New Booking' : 'Upcoming'}} <dfn class="sa-h-xs sa-h-sm" v-if="utid !== (4 || 3)">Appointments</dfn> </label>
                  </span>
                  <span>
                    <input type="radio" id="compAppoint" v-model="radio" name="compAppoint" value="4" />
                    <label for="compAppoint">Completed <dfn class="sa-h-xs sa-h-sm">Appointments</dfn></label>
                  </span>
                  <span>
                    <input type="radio" id="canAppoint" v-model="radio" name="canAppoint" value="5" />
                    <label for="canAppoint">Cancelled <dfn class="sa-h-xs sa-h-sm">Appointments</dfn></label>
                  </span>
                  <span v-if="utid !== (4 || 3)">
                    <input type="radio" id="unCompleted" v-model="radio" name="unCompleted" value="11" />
                    <label for="unCompleted">Incompleted <dfn class="sa-h-xs sa-h-sm">Appointments</dfn></label>
                  </span>
                  <span>
                    <input type="radio" id="noshow" v-model="radio" name="noshow" value="7" />
                    <label for="noshow">No Show</label>
                  </span>
                </div>
              </div>
              <!-- <div class="sa-card sa-card-gray sa-card-noshadow" v-show="slctService ==='ST1'">
                        <strong class="sa-d-block">Appointments</strong>
                        <div class="sa-appoint-list">
                            <span><input type="radio" id="upComingAppoint" v-model="radio" name="appointment" value="3" checked> <label for="upComingAppoint">Upcoming Appointments</label></span>
                            <span><input type="radio" id="compAppoint" v-model="radio" name="appointment" value="4"> <label for="compAppoint">Completed Appointments</label></span>
                            <span><input type="radio" id="canAppoint" v-model="radio" name="appointment" value="5"> <label for="canAppoint">Cancelled Appointments</label></span>
                        </div>
              </div>-->
            </div>
            <div v-if="eflag" class="sa-col-xs12 sa-col-sm12 sa-col-md8 sa-col-lg8">
              <div class="sa-appt-sticky">
                <content-loader v-if="loader" />
                <ul class="sa-card-list sa-new-appt-list" v-else-if="utid === 4 || utid === 3">
                  <li v-for="list in serviceAptList" :key="list.id">
                    <div @click="gotoAptDetails(list)">
                      <AppointmentListCard v-if="(radio === '3' || radio === '11' || radio === '4')" :data="list" :totalpages="totalpages" :currentPage="currentPage"/>
                    </div>
                    <NoShow v-if="(radio === '5' || radio === '7')" :data="list" :totalpages="totalpages" :currentPage="currentPage"/>
                  </li>
                  <infinite-loading @infinite="serviceAptHandler" spinner="waveDots"></infinite-loading>
                </ul>
                <template v-else>
                  <up-coming-appointments-list
                    :apList="apList"
                    :totalpages="totalpages" :currentPage="currentPage"
                    v-show="(radio === '3' || radio === '11')"
                  />
                  <completed-appintment-list class="sa-hide-dashed-line"
                    :apList="apList"
                    :totalpages="totalpages" :currentPage="currentPage"
                    v-show="radio === '4'"
                  />
                  <cancelled-appointment-list class="sa-hide-dashed-line"
                    :apList="apList"
                    :totalpages="totalpages" :currentPage="currentPage"
                    v-show="radio === '5'"
                  />
                  <no-show-list class="sa-hide-dashed-line"
                    :apList="apList"
                    :totalpages="totalpages" :currentPage="currentPage"
                    v-show="radio === '7'"
                  />
                </template>
              </div>
            </div>
            <div class="sa-col-xs12 sa-col-sm8 sa-col-md8 sa-col-lg8" v-else>
              <no-data-found />
            </div>
          </div>
      </div>
    </div>
  </main>
</template>
<script>
import UpCmngAppointListVue from "../../components/appointments/UpCmngAppointList.vue";
import CompletedAppointListVue from "../../components/appointments/CompletedAppointList.vue";
import CancelledAppointmentListVue from "../../components/appointments/CancelledAppointmentList.vue";
import NoShowListVue from "../../components/appointments/NoShowList.vue";
import { pro_url,lab_url,nurse_url } from "../../../config/endpoints";
import ContentLoaderVue from "../../components/common/ContentLoader.vue";
import NoDataFoundVue from "../../components/common/NoDataFound.vue";
import _ from "lodash";
import AppointmentListCard from "../../components/nurse/AppointmentListCard.vue";
import NoShow from "../../components/nurse/NoShow.vue";
import InfiniteLoading from "vue-infinite-loading";
export default {
  components: {
    "up-coming-appointments-list": UpCmngAppointListVue,
    "completed-appintment-list": CompletedAppointListVue,
    "cancelled-appointment-list": CancelledAppointmentListVue,
    "no-show-list": NoShowListVue,
    "content-loader": ContentLoaderVue,
    "no-data-found": NoDataFoundVue,
    AppointmentListCard,
    NoShow,
    InfiniteLoading
},
  data() {
    return {
      radio: "3",
      slctService: "all",
      currentPage: 1,
      apList: [],
      serviceAptList:[],
      eflag: true,
      // loading: false,
      loader:false,
      userInfo: {},
      totalpages: 1,
      aptLists: [],
      // aptLists: [{name:'Home Visit'},{name:'Video Consultsation'}]
    };
  },
  created() {
    let _self = this;
    _self.userInfo = JSON.parse(_self.$localStorage.get("userdata"));
    if (_self.$route.query.stid) {
        _self.slctService = _self.$route.query.stid;
      }
    if (_self.$route.query.app_stat) {
      _self.radio = _self.$route.query.app_stat;
    }
    this.utid = JSON.parse(this.$localStorage.get("utid"))
    if(this.utid === 4 || this.utid === 3){
      _self.serviceAptHandler();
    }else{
      _self.getList(1)
    }
  },
  methods: {
    serviceAptHandler($state){
      let _self = this;
      if (_self.currentPage == 1){
        _self.loader = true;
      }
      let data = {
        limit: 4,
        page: _self.currentPage,
        status: _self.radio
      };
      this.api = this.utid === 4 ? `${lab_url}/appointment/list` : `${nurse_url}/appointment/list`
      _self.$store.dispatch("httpPost", {uri: _self.api,body: data}).then(response => {
        if (response && response.status === 1000) {
          _self.loader = false;
          if (!_.isEmpty(response.data)) {
            _self.currentPage += 1
            _self.serviceAptList.push(...response.data.data);
            _self.eflag = true;
            if($state)
            $state.loaded()
          } else {
            if (_self.currentPage == 1)
            _self.eflag = false;
            if($state)
            $state.complete()
          }
          } else if (response && response.status == '2001'){
              _self.$store.dispatch('SET_ALERTMESSAGE', { 'msg': 'Session Expired. Please login again', class: 'sa-a-danger' })
              _self.loader = false;
              _self.$localStorage.remove("token")
              _self.$localStorage.remove("userdata")
              _self.$router.push({ path: '/' })
              if($state)
              $state.complete()
          } else {
            _self.eflag = false
            _self.loader = false;
            if($state)
            $state.complete()
          }
        })
        .catch(e => {
          _self.eflag = false
          _self.loader = false;
        });
    },
    gotoAptDetails(list){
      if(this.$route.query.app_stat){
        this.$router.push(`/new-booking-details?apnt_id=${list.apnt_id}&is_multi_patient=${list.is_multi_patient}&app_stat=${this.$route.query.app_stat}`)
      }else{
        this.$router.push(`/new-booking-details?apnt_id=${list.apnt_id}&is_multi_patient=${list.is_multi_patient}`)
      }
    },
    getList(i) {
      let _self = this;
      _self.loader = true;
      let wobj = {
        limit: 4,
        page: i,
        stid: _self.slctService,
        status: _self.radio
      };
      if (_self.slctService == 'ST1') {
        wobj.followUp = false
      }
      if (_self.slctService == 'ST11') {
        wobj.stid = 'ST1'
        wobj.followUp = true
      }
      this.utid = JSON.parse(this.$localStorage.get("utid"))
      if(_self.utid === 4){
        _self.api = `${lab_url}/appointment/list`
        delete wobj.stid
      }else if(_self.utid === 3){
        _self.api = `${nurse_url}/appointment/list`
        delete wobj.stid
      }else{
        _self.api = `${pro_url}/aptList`
      }
      _self.$store
        .dispatch("httpPost", {
          uri: _self.api,
          body: wobj
        })
        .then(response => {
          if (response && response.status === 1000) {
            if (!_.isEmpty(response.data)) {
              _self.currentPage = i
              _self.apList = response.data.data;
              _self.totalpages = response.data.metadata[0].total_pages;
              _self.eflag = true;
            } else {
              _self.eflag = false;
            }
            _self.loader = false;
          } else if (response && response.status == '2001'){
              _self.$store.dispatch('SET_ALERTMESSAGE', { 'msg': 'Session Expired. Please login again', class: 'sa-a-danger' })
              _self.loader = false;
              _self.$localStorage.remove("token")
              _self.$localStorage.remove("userdata")
              _self.$router.push({ path: '/' })
          } else {
            // _self.$router.push({path:'/404-error'})
            _self.eflag = false
            _self.loader = false;
          }
        })
        .catch(e => {
          // _self.$router.push({path:'/404-error'})
            _self.eflag = false
          _self.loader = false;
        });
    }
  },
  watch: {
    radio: {
      immediate: false,
      handler(val) {
        let _self = this;
        _self.$router.push({ query: { stid: this.slctService, app_stat: val } }).catch(err => {});
        _self.getList(1);
        _self.currentPage = 1
        _self.serviceAptList = []
      }
    },
    slctService: {
      immediate: false,
      handler(val) {
        let _self = this;
        _self.$router.push({ query: { stid: val,  app_stat: this.radio} }).catch(err => {});
        _self.getList(1);
      }
    }
  }
};
</script>
